// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
// 引入 Beidou Monitor
import './utils/beidou.js'
import './utils/wmda.js'
import './element-variables.scss'
import { Style, Picker, CascadePicker, DatePicker, Toast, Popup } from 'cube-ui'

Vue.use(Style)
Vue.use(Picker)
Vue.use(CascadePicker)
Vue.use(DatePicker)
Vue.use(Toast)
Vue.use(Popup)
Vue.use(ElementUI)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})
window.onunhandledrejection = (event) => {
  console.log(`UNHANDLEDREJECTION: ${event.reason}`)
  return null
}



// WEBPACK FOOTER //
// ./src/main.js